import { render } from "./UpdateMandateContractDialog.vue?vue&type=template&id=2b539e12"
import script from "./UpdateMandateContractDialog.vue?vue&type=script&lang=js"
export * from "./UpdateMandateContractDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__